import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight, faCheck } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'reactstrap';
import "../../assets/css/stepper.css"
export default function Stepper({ steps = [], activeStep = 1, setActiveStep, children, onSubmit, hideButton = false }) {

    //Função que passa para o proximo passo
    const nextStep = () => {
        const errors = steps[activeStep - 1].validateStep ? steps[activeStep - 1].validateStep() : false;
        if (!errors || errors.length == 0) {
            if (activeStep >= steps.length && onSubmit) {
                onSubmit();
            }
            setActiveStep(activeStep >= steps.length ? activeStep : activeStep + 1);
        }
    };

    //Função que passa para o passo anterior
    const previousStep = () => setActiveStep(activeStep >= 2 ? activeStep - 1 : activeStep);

    return (
        <div className="stepper" id="stepper2">
            <div className="steps-container">
                <div className="steps d-flex align-items-center justify-content-around justify-content-lg-between">
                    {steps && steps.map((value, key) => {
                        const activeGradient = `${activeStep >= key + 1 ? "bg-success" : "bg-secondary"}`
                        const activeGradientLongBar = `${activeStep > key + 1 ? "bg-success" : "bg-secondary"}`
                        return (
                            <div key={key} className={`step d-none ${key + 1 === activeStep ? 'activeStep1' : key + 1 === activeStep + 1 ? "activeStep2" : ""} d-lg-block`} icon="fa fa-pencil-alt" id="1">
                                <div className="step-title d-flex align-items-start justify-content-left">
                                    <span className="step-number display-6 ">{key < 9 ? `0${key + 1}` : `${key + 1}`}</span>
                                    <div className="ms-2 step-text d-flex flex-column">{value.text}{value.optional ? <span style={{ fontSize: "9pt" }}>(Opcional)</span> : <></>}</div>
                                </div>
                                <div className="mt-2 step-title d-flex align-items-center justify-content-start ">
                                    {value.icon && <span className={` me-2 d-flex align-items-center justify-content-center bg-gradient ${activeGradient}`} style={{ color: "#fff", borderRadius: "100%", width: "50px", height: "50px" }}><FontAwesomeIcon icon={value.icon} /></span>}
                                    {key != steps.length - 1 &&
                                        <>
                                            <div style={{ width: "10px", height: "10px", borderRadius: "50px" }} className={`me-2 bg-gradient ${activeGradient}`}></div>
                                            <div style={{ width: "70px", height: "10px", borderRadius: "50px" }} className={` bg-gradient ${activeGradientLongBar}`}></div>
                                        </>
                                    }
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className="stepper-content-container">
                <div className="mt-4 d-flex align-items-center justify-content-between">
                    <h4 className=' m-3 fw-normal'><FontAwesomeIcon icon={steps[activeStep - 1].icon} className={"me-3"} />{steps[activeStep - 1].text}</h4>
                    {steps[activeStep - 1].btnAdicionar ?
                        <Button color='primary' className='me-4 fw-bold bg-gradient d-flex align-items-center' onClick={steps[activeStep - 1].btnAdicionar}>
                            {steps[activeStep - 1].btnAdicionarText ? steps[activeStep - 1].btnAdicionarText : "+ Adicionar"}
                        </Button>
                        : <></>}
                </div>

                {children}
                {!hideButton &&
                    <div className='d-flex align-items-center justify-content-center'>
                        {activeStep !== 1
                            ?
                            <Button outline color='success' className='me-4  bg-gradient d-flex align-items-center' onClick={previousStep}><FontAwesomeIcon icon={faArrowLeft} className={"me-3"} /> Anterior</Button>
                            :
                            <></>
                        }
                        <Button color='success' className='bg-gradient d-flex align-items-center' onClick={nextStep}> {activeStep === steps.length ? <FontAwesomeIcon icon={faCheck} className={"me-3"} /> : <></>} {activeStep === steps.length ? "Concluir" : `Próximo`} {activeStep === steps.length ? <></> : <FontAwesomeIcon icon={faArrowRight} className={"ms-3"} />}</Button>
                    </div>
                }

            </div>
        </div>
    )
}